import React, { useState } from "react";
import "./Our_Services.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import Common_Title from "../../common_components/common_title/Common_Title";
import { useNavigate } from "react-router-dom";

const Our_Services = () => {
  const [hoveredImg, setHoveredImg] = useState(
    "/assets/images/home/our_services/clients_images/furniture.jpeg"
  );

  const navigate = useNavigate();

  const [animate, setAnimate] = useState(false);

  const handleHover = (img) => {
    setAnimate(true); // trigger slide-out
    setTimeout(() => {
      setHoveredImg(img); // change image after slide-out
      setAnimate(false); // reset (so slide-in runs)
    }, 300); // duration should match CSS slide-out
  };

  // const services = [
  //   {
  //     title: "Residential Interior Design",
  //     img: "/assets/images/home/our_services/img1.png",
  //     link: "/services/residential-interior-design",
  //   },
  //   {
  //     title: "Commercial Interior Design",
  //     img: "/assets/images/home/our_services/img2.png",
  //     link: "/services/commercial-interior-design",
  //   },
  //   {
  //     title: "Interior Design Consultation",
  //     img: "/assets/images/home/our_services/img1.png",
  //     link: "/services/interior-design-consultation",
  //   },
  //   {
  //     title: "Renovation and Remodeling",
  //     img: "/assets/images/home/our_services/img2.png",
  //     link: "/services/interior-design-consultation",
  //   },
  //   {
  //     title: "Interior 2D/3D Layouts",
  //     img: "/assets/images/home/our_services/img1.png",
  //     link: "/services/interior-design-consultation",
  //   },
  // ];

    const services = [
    {
      title: "Furniture & Custom Carpentry ",
      img: "/assets/images/home/our_services/clients_images/furniture.jpeg",
      link: "/services/furniture-custom-carpentry",
    },
    {
      title: "Modular Kitchens ",
       img: "/assets/images/home/our_services/clients_images/klitchen.jpeg",
      link: "/services/modular-kitchens",
    },
    {
      title: "Acoustic & Home Theatre Solutions ",
      img: "/assets/images/home/our_services/clients_images/acoustic.jpeg",
      link: "/services/acoustic-theatre-design",
    },
    {
      title: "Civil Work & Renovation ",
      img: "/assets/images/home/our_services/clients_images/civil.jpeg",
      link: "/services/civil-renovation-work",
    },
    {
      title: "False Ceiling & POP Designs",
       img: "/assets/images/home/our_services/clients_images/ceiling.jpeg",
      link: "/services/false-ceiling-designs",
    },
     {
      title: "Professional Painting Services ",
      img: "/assets/images/home/our_services/clients_images/painting.jpeg",
      link: "/services/professional-painting-services",
    },
     {
      title: "Home Automation",
      img: "/assets/images/home/our_services/clients_images/home.jpeg",
      link: "/services/home-automation",
    },
     {
      title: "3D Designing & Visualization",
      img: "/assets/images/home/our_services/clients_images/3d.jpeg",
      link: "/services/3D-designing-visualization",
    },
  ];


  return (
    <section className="Our_Services">
      <div className="container">
        <div className="main_content">
          <Common_Title
            pageTitle="OUR SERVICES"
            boxText="Explore  "
            subText=" Our Comprehensive Design Services"
            darkText="Creating beautiful, functional spaces that reflect your unique style."
            simpleText="Explore our portfolio of innovative architectural and interior design projects crafted with precision."
          />

          <div className="list_main_div">
            <div className="right_side_main_div">
              <div className="fixed_img_holder">
                <img
                  src={hoveredImg}
                  alt="Service Preview"
                  className={`type_img ${animate ? "slide_out" : "slide_in"}`}
                />
              </div>

              <div>
                {services.map((service, idx) => (
                  <div
                    key={idx}
                    className="text_img_holder"
                    onMouseEnter={() => handleHover(service.img)}
                    onClick={() => {
                      navigate(service?.link);
                    }}
                  >
                    <div className="tab_holder">
                      <div className="square"></div>
                      <div className="title_div">
                        <p className="text">{service.title}</p>
                      </div>
                      <div className="icon_holder">
                        <FontAwesomeIcon
                          icon={faAngleRight}
                          className="arrow_icon"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Our_Services;
